import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import FolderModalContent from "./ModalContent/FolderModalContent";
import { useFolderList } from "./hooks/useMaterial";
type Props = {};

const folderDataColumns = (
  handleUpdateFolder: (row: any, Status: string) => void
) => [
  {
    name: "Parent Folder Name",
    selector: (row: { ParentFolderName: number | string }) =>
      row.ParentFolderName,
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "Folder Name",
    selector: (row: { FolderName: string }) => row?.FolderName,
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "Created At",
    selector: (row: { CreatedAt: string }) => {
      return row?.CreatedAt?.split(".")[0].replace("T", " ");
    },
    sortable: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: "Action",
    // width: "130px",
    cell: (row: any) => (
      <button
        onClick={() => handleUpdateFolder(row, "Update")}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const Folders = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    media: "",
    name: "",
    parent: "",
  });

  const [filtersState, setFiltersState] = useState<any>({
    search: "",
    page: 1,
    limit: 10,
  });

  const { data: folderListData, isLoading: folderListDataLoading } =
    useFolderList({
      enable: true,
      params: {
        search: filtersState?.search,
        page: filtersState?.page,
        limit: filtersState?.limit,
      },
    });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setEditStatus("");
    setFormData({
      media: "",
      name: "",
      parent: "",
    });
    // setSelectedRow("");
  };
  const handleClose = () => {
    setEditStatus("");
    setIsModalOpen(false);
    setFormData({
      media: "",
      name: "",
      parent: "",
    });
    // setSelectedRow("");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleUpdateFolder = (row: any, status: string) => {
    console.log("🚀 ~ Folders.tsx:106 ~ handleUpdateFolder ~ row:", status);
    setSelectedRow(row);
    toggleModal();
    setEditStatus(status);
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Folder"
        buttons={[
          {
            label: "+ Add Folder",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Folder list"
        data={folderListData?.data?.data || []}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={folderListDataLoading}
        columns={folderDataColumns(handleUpdateFolder)}
        SearchPlaceholder="Search by Folder Name"
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          folderListData?.data?.pagination?.total_records || 0
        }
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        // filterOptions={filterOptions}
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={editStatus === "Update" ? "Edit Folder" : "Add Folder"}
        size="md"
        content={
          <FolderModalContent
            selectedRow={selectedRow}
            handleClose={handleClose}
            editStatus={editStatus}
            setEditStatus={setEditStatus}
            formData={formData}
            setFormData={setFormData}
            isSubmitting={isSubmitting} // ✅ pass
            setIsSubmitting={setIsSubmitting}
          />
        }
      />
    </div>
  );
};

export default Folders;
